import type { PromotionProductTypeEnum } from "@/libs/client/goApi/promotion/promotionServiceInterface/getPromotionListInterface";

export function mergePromotionProductTypesIntoParams(
  promotionProductTypes: PromotionProductTypeEnum[],
  params: object,
  promotionProductCategory: string[],
) {
  const promotionProductArrayTypes = promotionProductTypes.map(
    (itemType, index) => ({
      [`type[${index}]`]: itemType,
    }),
  );

  let combinedObject = Object.assign({}, ...promotionProductArrayTypes);

  if (
    promotionProductCategory.length === 0 ||
    promotionProductCategory[0] === undefined
  ) {
    combinedObject = Object.assign(combinedObject);
  } else {
    const promotionProductArrayCategory = promotionProductCategory.map(
      (itemCategory, index) => ({
        [`category[${index}]`]: itemCategory,
      }),
    );
    combinedObject = Object.assign(
      combinedObject,
      ...promotionProductArrayCategory,
    );
  }

  const newParams = { ...params, ...combinedObject };
  delete newParams.type;
  delete newParams.category;

  return newParams;
}
